import as1141_11_1 from './As/1141_11_1/Config';
import as1289_3_6_1 from './As/1289_3_6_1/Config';
import astmC136 from './Astm/C136/Config';
import astmD6913 from './Astm/D6913/Config';
import bsen933_1 from './BsEn/Config';
import bseniso17982_4 from './BsEnIso/Config';

export default {
  ...astmD6913,
  ...astmC136,
  ...bseniso17982_4,
  ...bsen933_1,
  ...as1141_11_1,
  ...as1289_3_6_1,
};
